module.exports = __webpack_public_path__ + "img/ki.b346fea4.png";